/**
 * Public-facing emails, read from bake-time env vars with a sensible fallback.
 *
 * Prod (bake): set REACT_APP_EMAIL_* explicitly.
 * Preview / dev: fallback to `contact@itercatus.fr` to preserve current UX.
 *
 * Category matrix (documented in docs/secrets_operations.md §2):
 *   info          → contact public général (site vitrine, FAQ)
 *   membership    → adhésion / cotisation / espace membre
 *   partners      → demandes de partenariat professionnel
 *   notifications → from/reply-to des emails automatiques
 *   institutional → contact institutionnel (rarement affiché)
 */
const FALLBACK = "contact@itercatus.fr";

export const PUBLIC_EMAILS = {
  info: process.env.REACT_APP_EMAIL_INFO || FALLBACK,
  membership: process.env.REACT_APP_EMAIL_MEMBERSHIP || FALLBACK,
  partners: process.env.REACT_APP_EMAIL_PARTNERS || FALLBACK,
  notifications: process.env.REACT_APP_EMAIL_NOTIFICATIONS || FALLBACK,
  institutional: process.env.REACT_APP_EMAIL_INSTITUTIONAL || FALLBACK,
};
